import { formatDateTime } from '../format';
import { t } from '../i18n/pt-BR';
import { usePlan } from '../plan/PlanContext';

/** Aviso fixo: plano publicado (ou substituído) é somente leitura. */
export function PlanBanner() {
  const { selected } = usePlan();
  if (!selected || selected.situacao === 1) return null;
  if (selected.situacao === 3) {
    return (
      <div className="banner warn" role="note">
        {t.plan.supersededBanner}
      </div>
    );
  }
  const when = selected['dt-hr-publicacao'] ? formatDateTime(selected['dt-hr-publicacao']) : '—';
  return (
    <div className="banner info" role="note">
      {t.plan.publishedBanner(when, selected['usuario-publicacao'] ?? '—')}
    </div>
  );
}
